module.exports = __webpack_public_path__ + "img/fp-unfolded.b00d866f.webp";